import config from '../../config';
import Auth0AuthenticationGuard from './auth0AuthenticationGuard';
import LogycaAuthenticationGuard from './logycaAuthenticationGuard';

export default config.isLogycaFlavor ? LogycaAuthenticationGuard : Auth0AuthenticationGuard;
